export default () => ({
  works: null,
  work: null,
  links: null,
  meta: null,
  hasData: false,
});
